import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const UserAgent = (store) => ({
  path: ROUTE.USER_AGENT,
  component: createLazyRouteComponent({
    store,
    loadComponent: () => import('./UserAgentContainer'),
  })
})

export default UserAgent
